import React from 'react';

/**
 * GenAIOps Overview Help Content
 */
const GenAIOpsOverviewHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          GenAIOps Overview
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          The Overview dashboard provides a comprehensive view of your AI operations, including LLM usage metrics, performance statistics, and cost tracking across all your AI applications.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Dashboard Widgets
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          The dashboard displays key metrics for your AI operations:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Total Traces</span>: Number of LLM invocations tracked</p>
          <p>&#8226; <span className="font-medium">Average Latency</span>: Mean response time across all calls</p>
          <p>&#8226; <span className="font-medium">Success Rate</span>: Percentage of successful completions</p>
          <p>&#8226; <span className="font-medium">Token Usage</span>: Input and output token consumption</p>
          <p>&#8226; <span className="font-medium">Cost Analysis</span>: Spend breakdown by model and application</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Customizing Your Dashboard
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Click the <span className="font-semibold">Customize</span> button to personalize your dashboard:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; Add or remove widgets based on your needs</p>
          <p>&#8226; Drag widgets to rearrange the layout</p>
          <p>&#8226; Resize widgets for better visibility</p>
          <p>&#8226; Save custom views for different use cases</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Quick Navigation
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Use the tabs above to navigate to specific areas: <span className="font-medium">Observability</span> for traces and sessions, <span className="font-medium">Registry</span> for prompts and datasets, <span className="font-medium">Evaluation</span> for testing, and <span className="font-medium">Governance</span> for approval workflows.
        </p>
      </div>

    </>
  );
};

export default GenAIOpsOverviewHelp;
